<template>
  <div class="waybill-event-timeline">
    <section v-for="group in dateGroups" :key="group.date" class="waybill-event-day">
      <h3>{{ group.date }}</h3>
      <div v-for="event in group.events" :key="event.key" class="waybill-event" :class="[`waybill-event--${event.category}`, { 'waybill-event--resolved': event.resolved }]">
        <button type="button" class="waybill-event__content" @click="$emit('locate', event)">
          <strong>{{ event.title }}<span v-if="event.category === 'alarm' || event.source.sourceAlarmNo" class="waybill-event__alarm">{{ event.resolved ? '解' : '警' }}</span></strong>
          <span v-if="showWaybill && event.waybillNo" class="waybill-event__waybill">{{ event.waybillNo }}</span>
          <span v-if="event.ongoing" class="waybill-event__remark">区间末仍在停车，已观测 {{ durationText(event.duration) }}</span>
          <span v-else-if="event.title === '停车结束'" class="waybill-event__remark">已结束 · 持续 {{ durationText(event.duration) }}</span>
          <span v-if="event.remark && event.remark !== event.title" class="waybill-event__remark">{{ event.remark }}</span>
          <span v-if="event.address" class="waybill-event__address">{{ event.address }}</span>
          <time>{{ formatTime(event.time) }}</time>
        </button>
      </div>
    </section>
    <div v-if="!events.length" class="waybill-event-timeline__empty">暂无符合条件的事件</div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'WaybillEventTimeline',
  props: {
    events: { type: Array, default: () => [] },
    showWaybill: { type: Boolean, default: false }
  },
  computed: {
    dateGroups() {
      const groups = new Map()
      this.events.forEach(event => {
        const date = dayjs(event.time).format('YYYY-MM-DD')
        if (!groups.has(date)) groups.set(date, { date, events: [] })
        groups.get(date).events.push(event)
      })
      return Array.from(groups.values())
    }
  },
  methods: {
    formatTime(value) { return dayjs(value).format('YYYY-MM-DD HH:mm:ss') },
    durationText(value) {
      const seconds = Math.max(0, Math.floor(Number(value) || 0))
      const days = Math.floor(seconds / 86400)
      const hours = Math.floor(seconds % 86400 / 3600)
      const minutes = Math.floor(seconds % 3600 / 60)
      return `${days ? `${days}天` : ''}${hours ? `${hours}小时` : ''}${minutes}分${seconds % 60}秒`
    }
  }
}
</script>

<style scoped>
.waybill-event-timeline { padding: 6px 24px 16px; }
.waybill-event-day h3 { margin: 15px 0 18px; color: #606266; font-size: 15px; font-weight: 400; }
.waybill-event { position: relative; padding: 0 0 24px 29px; border-left: 1px solid #1677ff; margin-left: 5px; }
.waybill-event:last-child { border-left-color: transparent; }
.waybill-event::before { position: absolute; top: 3px; left: -5px; width: 9px; height: 9px; border-radius: 50%; background: #1677ff; content: ''; }
.waybill-event--alarm::before { background: #ff4147; }
.waybill-event__content { display: flex; width: 100%; flex-direction: column; gap: 8px; padding: 0; border: 0; background: transparent; text-align: left; font-family: inherit; cursor: pointer; }
.waybill-event__content:focus-visible { outline: 2px solid #1677ff; outline-offset: 3px; }
.waybill-event__content strong { color: #1677ff; font-size: 15px; font-weight: 500; line-height: 22px; }
.waybill-event--alarm .waybill-event__content strong { color: #f5222d; }
.waybill-event__alarm { display: inline-flex; width: 17px; height: 17px; align-items: center; justify-content: center; margin-left: 5px; border-radius: 50%; color: #fff; background: #ff4147; font-size: 11px; vertical-align: 1px; }
.waybill-event--resolved::before, .waybill-event--resolved .waybill-event__alarm { background: #1dc588; }
.waybill-event--resolved .waybill-event__content strong { color: #139c68; }
.waybill-event__remark, .waybill-event__address, .waybill-event__waybill { color: #606266; font-size: 12px; line-height: 20px; overflow-wrap: anywhere; }
.waybill-event__waybill { color: #909399; }
.waybill-event__content time { color: #909399; font-size: 12px; line-height: 20px; }
.waybill-event-timeline__empty { padding: 24px 0; color: #909399; font-size: 13px; text-align: center; }
</style>
